export const PROCESOS_EMPRESA_LIST_PATH = '/procesos/empresas';
export const PROCESOS_EMPRESA_PAGE_SIZE = 10;

export interface ProcesosEmpresaLocationState {
  procesosSearch?: string;
  returnPath?: string;
  empresaLabel?: string;
  workflowNombre?: string;
}

function withSearch(path: string, search = ''): string {
  const query = search.startsWith('?') ? search : search ? `?${search}` : '';
  return `${path}${query}`;
}

export function procesosEmpresasPath(search = ''): string {
  return withSearch(PROCESOS_EMPRESA_LIST_PATH, search);
}

export function procesosEmpresaWorkflowsPath(empresaId: number | string, search = ''): string {
  return withSearch(`${PROCESOS_EMPRESA_LIST_PATH}/${empresaId}/workflow`, search);
}

export function procesosEmpresaWorkflowPeriodosPath(
  empresaId: number | string,
  workflowId: number | string,
  search = '',
): string {
  return withSearch(`${PROCESOS_EMPRESA_LIST_PATH}/${empresaId}/workflow/${workflowId}/periodos`, search);
}

export function procesosEmpresaQueryFilters(search: string): { filterName: string; filterValue: string }[] {
  const q = search.trim();
  return q ? [{ filterName: 'query', filterValue: q }] : [];
}

export function parseProcesosEmpresaId(pathname: string): number | null {
  const match = pathname.match(/^\/procesos\/empresas\/(\d+)(?:\/|$)/);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function parseProcesosEmpresaWorkflowId(pathname: string): number | null {
  const match = pathname.match(/^\/procesos\/empresas\/\d+\/workflow\/(\d+)\/periodos$/);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function grupoEmpresaLabel(grupo?: {
  alias?: string | null;
  grpAliasEquilibrio?: string | null;
  grpAliasDecomsa?: string | null;
} | null): string {
  return grupo?.alias?.trim()
    || grupo?.grpAliasEquilibrio?.trim()
    || grupo?.grpAliasDecomsa?.trim()
    || '';
}

export function empresaProcesosLabel(empresa?: {
  rfc?: string | null;
  razonSocial?: string | null;
} | null): string {
  const rfc = empresa?.rfc?.trim();
  const razon = empresa?.razonSocial?.trim();
  if (rfc && razon) return `${rfc} · ${razon}`;
  return razon || rfc || '';
}
